import { useState, useEffect, useRef } from "react";
import MarkdownRenderer from "react-markdown-renderer";
import "./airachat.css";
import {
  chatHistoryOneDay,
  chatHistoryOneMonth,
  chatHistorySevenDay,
  generateChat,
} from "../../../Redux/chat/chat.action";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDateForChatComponent,
  formatMarkdownResponse,
  isValidImageType,
} from "../../../utils/utils";
import axios from "axios";
import {
  POST_AIRA_AUDIO,
  POST_AIRA_SPEAKER,
  POST_UPLOAD_PDF_FILE,
} from "../../../utils/api";
import { SpeakerCopyButton } from "./audioSpeaker";
import isFirstDayOfMonth from "date-fns/isFirstDayOfMonth";
import Loader from "../../../utils/loader/loader";
import ToastMessage from "../../../utils/toasts/toastMessage";

const AiraChatBody = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const inputRef = useRef(null);
  const [inputPrompt, setInputPrompt] = useState("");
  const [promptQues, setPromptQues] = useState("");
  const [chatResponse, setChatResponse] = useState(null);
  const [sessionHistory, setSessionHistory] = useState([]);
  const [historyOneDay, setHistoryOneDay] = useState([]);
  const [historySevenDay, setHistorySevenDay] = useState([]);
  const [question, setQuestion] = useState(
    "Our AI tools help students understand better, improve their learning.",
  );

const [uploadedFilePreview, setUploadedFilePreview] = useState(null);

  // all states for edit chat from redux
  const [showEditBtn, setShowEditBtn] = useState(true);
  const [editing, setEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState([]);

  // mic recorder states
  const [isRecording, setIsRecording] = useState(false);
  const [recordingStarted, setRecordingStarted] = useState(false);
  const recordingStartedRef = useRef(false);

const [sentAttachments, setSentAttachments] = useState({});
  const imageInputRef = useRef(null);
  const docInputRef = useRef(null);
  const menuRef = useRef(null);

  // history open state for mobile
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  const [docResponse, setDocResponse] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  const store = useSelector((state) => state);

  const chatLoading = useSelector((state) => state?.ChatManager?.chatLoading);
  const chatResponseStore = useSelector(
    (state) => state?.ChatManager?.response,
  );

  const sessionChatHistoryStore = useSelector(
    (state) => state?.ChatManager?.sessionHistory,
  );

  const chatHistoryOneDayStore = useSelector(
    (state) => state?.ChatManager?.historyOneday,
  );
  const chatHistorySevenStore = useSelector(
    (state) => state?.ChatManager?.historySevenday,
  );
  const chatHistoryMonthStore = useSelector(
    (state) => state?.ChatManager?.historyMonth,
  );

  useEffect(() => {
    setChatResponse(chatResponseStore ? chatResponseStore : "");
    setSessionHistory(sessionChatHistoryStore ? sessionChatHistoryStore : []);
  }, [
    chatResponseStore,
    sessionChatHistoryStore,
    sessionChatHistoryStore?.length,
  ]);

  useEffect(() => {
    dispatch(chatHistoryOneDay(1));
    dispatch(chatHistorySevenDay(7));
    dispatch(chatHistoryOneMonth(30));
  }, [dispatch]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll("section[id]"));

    const scrollHandler = (entries) => {
      entries.forEach((entry) => {
        const section = entry.target;
        const sectionId = section.id;
        const sectionLink = document.querySelector(`a[href="#${sectionId}"]`);

        if (entry.intersectionRatio > 0) {
          section.classList.add("active");
          if (sectionLink) sectionLink.classList.add("active");
        } else {
          section.classList.remove("active");
          if (sectionLink) sectionLink.classList.remove("active");
        }
      });
    };

    const observer = new window.IntersectionObserver(scrollHandler);

    sections.forEach((section) => observer.observe(section));
    return () => {
      observer.disconnect();
    };
  }, []);

  const handleNewChat = () => {
    setSessionHistory([]);
    setHistoryOneDay([]);
    setHistorySevenDay([]);
    setInputPrompt("");
    setPromptQues("");
    setQuestion(
      "Our AI tools help students understand better, improve their learning.",
    );
    localStorage.removeItem("material_id");
     localStorage.removeItem("session_id");
    // localStorage.getItem("session_id");
  };

  useEffect(() => {
    localStorage.removeItem("session_id");
    localStorage.removeItem("material_id");
    setSessionHistory([]);
    setHistoryOneDay([]);
    setHistorySevenDay([]);
    setDocResponse(false);
  }, []);

  //Function to handle latest chat
  // const handleSendPrompt = async () => {
  //   setInputPrompt("");
  //   const sessionID = localStorage.getItem("session_id");
  //   setQuestion(inputPrompt ? inputPrompt : question);

  //   const payload = {
  //     user_query: inputPrompt || question,
  //     history: [],
  //     session_id: sessionID || "",
  //     imageFile: imageFile || null,
  //   };

  //   const result = await dispatch(generateChat(payload));

  //   if (!result.success) {
  //     setToastState({
  //       show: true,
  //       message: result.message || "Something went wrong! Try again.",
  //       type: "error",
  //     });
  //   }
  //   setInputPrompt("");
  //   setPromptQues("");
  //   setQuestion("Our AI tools help students understand better, improve their learning.");
  //   dispatch(chatHistoryOneDay(1));

  //    if (uploadedFilePreview?.url) URL.revokeObjectURL(uploadedFilePreview.url);
  // setUploadedFilePreview(null);
  // setImageFile(null);
  // };
  const handleSendPrompt = async () => {
  setInputPrompt("");
  const sessionID = localStorage.getItem("session_id");
  setQuestion(inputPrompt ? inputPrompt : question);

  const payload = {
    user_query: inputPrompt || question,
    history: [],
    session_id: sessionID || "",
    imageFile: imageFile || null,
  };

  // figure out which array is currently being rendered, so the new
  // message will land at this index once the store updates
  const currentList =
    sessionHistory?.length > 0
      ? sessionHistory
      : historyOneDay?.length > 0
        ? historyOneDay
        : historySevenDay;
  const nextIndex = currentList.length;

  const result = await dispatch(generateChat(payload));

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Something went wrong! Try again.",
      type: "error",
    });
  }

  // remember the attachment for this message index so it can render
  // inside the sent bubble
  if (uploadedFilePreview) {
    setSentAttachments((prev) => ({ ...prev, [nextIndex]: uploadedFilePreview }));
  }

  setInputPrompt("");
  setPromptQues("");
  setQuestion("Our AI tools help students understand better, improve their learning.");
  dispatch(chatHistoryOneDay(1));

  setUploadedFilePreview(null);
  setImageFile(null);
};

  const handleEditPrompt = async () => {
    setEditing(false);
    setShowEditBtn(true);

    const payload = {
      user_query: inputPrompt || question,
      history: [],
      session_id: localStorage.getItem("session_id") || "",
    };

    const result = await dispatch(generateChat(payload));

    if (!result.success) {
      setToastState({
        show: true,
        message: result.message || "Something went wrong! Try again.",
        type: "error",
      });
    }
    setInputPrompt("");
    setPromptQues("");
    setQuestion("Our AI tools help students understand better, improve their learning.");
    dispatch(chatHistoryOneDay(1));
  };

  const handleRegenerate = async (data) => {
    const getQuestion = data?.find((item) => item.role === "user")?.content;

    const payload = {
      user_query: getQuestion,
      history: [],
      session_id: localStorage.getItem("session_id") || "",
    };

    const result = await dispatch(generateChat(payload));

    if (!result.success) {
      setToastState({
        show: true,
        message: result.message || "Something went wrong! Try again.",
        type: "error",
      });
    }
    dispatch(chatHistoryOneDay(1));
  };

  const groupMessagesInPairs = (messages = []) => {
    const grouped = [];
    for (let i = 0; i < messages.length; i += 2) {
      const pair = [messages[i], messages[i + 1]].filter(Boolean); // avoid undefined
      grouped.push(pair);
    }
    return grouped;
  };

  const previousChatOneDay = async (e, prevSessionId) => {
    e.preventDefault();
    localStorage.removeItem("material_id");
    localStorage.setItem("session_id", prevSessionId || "");
    setHistorySevenDay([]);
    setSessionHistory([]);
    const session = chatHistoryOneDayStore.find(
      ({ session_id }) => session_id === prevSessionId,
    );
    if (!session || !Array.isArray(session.messages)) {
      setHistoryOneDay([]);
      return;
    }

    const groupedMessages = groupMessagesInPairs(session.messages);
    setHistoryOneDay(groupedMessages);
  };

  const previousChatSevenDay = async (e, prevSessionId) => {
    e.preventDefault();
    localStorage.removeItem("material_id");
    localStorage.setItem("session_id", prevSessionId || "");
    setSessionHistory([]);
    setHistoryOneDay([]);
    const session = chatHistorySevenStore.find(
      ({ session_id }) => session_id === prevSessionId,
    );
    if (!session || !Array.isArray(session.messages)) {
      setHistorySevenDay([]);
      return;
    }

    const groupedMessages = groupMessagesInPairs(session.messages);
    setHistorySevenDay(groupedMessages);
  };

  //mic recorder-to-mp3

  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]); // ✅ avoid rerender

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      audioChunksRef.current = []; // ✅ reset chunks

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data); // ✅ store in ref
        }
      };

      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });
        await sendToWhisper(audioBlob);
        audioChunksRef.current = []; // optional cleanup
      };

      mediaRecorder.start();
      setIsRecording(true);
    } catch (err) {
      setToastState({
        show: true,
        message: "Failed to start recording:",
        err,
        type: "error",
      });
    }
  };

  const stopRecording = () => {
    recordingStartedRef.current = true;
    setRecordingStarted(true);

    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      try {
        mediaRecorderRef.current.stop(); // triggers onstop
      } catch (err) {
        setToastState({
          show: true,
          message: "MediaRecorder stop failed:",
          err,
          type: "error",
        });
      }
    }

    // Stop mic access
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => {
        try {
          track.stop();
        } catch (e) {
          // console.warn("Failed to stop track:", e);
        }
      });
      streamRef.current = null;
    }

    setIsRecording(false);
  };

  //Image and doc upload

  const sendToWhisper = async (blob) => {
    const formData = new FormData();

    const audioFile = new File([blob], "voice.webm", { type: blob.type });
    formData.append("audio_file", audioFile);
    formData.append("session_id", localStorage.getItem("session_id") || "");
    formData.append("history", []);
    // formData.append("file", audioFile);

    const token = localStorage.getItem("access_token") || null;

    try {
      const response = await axios.post(POST_AIRA_AUDIO, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          // "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      const history = groupMessagesInPairs(response?.data?.updated_history);
      recordingStartedRef.current = false;
      setRecordingStarted(false);
      setSessionHistory(history);
      dispatch(chatHistoryOneDay(1));
    } catch (error) {
      setToastState({
        show: true,
        message: "Whisper API error:",
        error,
        type: "error",
      });
    }
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file && isValidImageType(file)) {
  //     localStorage.removeItem("material_id");
  //     setImageFile(file);
  //     setToastState({
  //       show: true,
  //       message: "Image uploaded! Ask your question",
  //       type: "success",
  //     });
  //   } else {
  //     setToastState({
  //       show: true,
  //       message: "Unsupported image format",
  //       type: "error",
  //     });
  //   }
  // };

  const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file && isValidImageType(file)) {
    localStorage.removeItem("material_id");
    setImageFile(file);
    setUploadedFilePreview({
      type: "image",
      url: URL.createObjectURL(file),
      name: file.name,
    });
    setToastState({
      show: true,
      message: "Image uploaded! Ask your question",
      type: "success",
    });
  } else {
    setToastState({
      show: true,
      message: "Unsupported image format",
      type: "error",
    });
  }
};

  // const handleDocUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImageFile(null);
  //     submitFile(file);
  //   } else {
  //     setToastState({
  //       show: true,
  //       message: "Unsupported document format",
  //       type: "error",
  //     });
  //   }
  // };

  const handleDocUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    setImageFile(null);
    setUploadedFilePreview({
      type: "doc",
      url: null,
      name: file.name,
    });
    submitFile(file);
  } else {
    setToastState({
      show: true,
      message: "Unsupported document format",
      type: "error",
    });
  }
};

const handleRemoveAttachment = () => {
  if (uploadedFilePreview?.url) URL.revokeObjectURL(uploadedFilePreview.url);
  setUploadedFilePreview(null);
  setImageFile(null);
  localStorage.removeItem("material_id");
};

   const submitFile = async (file) => {
    setLoading(true);
    const token = localStorage.getItem("access_token") || null;
    const formData = new FormData();

    formData.append("file", file);
    formData.append("subject", null);
    formData.append("chapter", null);
    formData.append("concept", null);

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const resp = await axios.post(POST_UPLOAD_PDF_FILE, formData, {
        headers,
        withCredentials: true,
      });

      if (resp.status === 200) {
        const material_id = resp.data.material_id;
        localStorage.setItem("material_id", material_id);
        setLoading(false);
        setToastState({
          show: true,
          message: "Document uploaded! Ask your question",
          type: "success",
        });
      } else {
        setLoading(false);
        setToastState({
          show: true,
          message: "Something went wrong! Try again.",
          type: "error",
        });
      }
    } catch (error) {
      setLoading(false);
      setToastState({
        show: true,
        message: `${error?.response?.data?.detail || "Network error"} `,
        type: "error",
      });
    }
  };

  // const sendDocument = async () => {
  //   setInputPrompt("");
  //   setDocResponse(true);
  //   const id = localStorage.getItem("material_id");
  //   const formData = new FormData();

  //   if (id) {
  //     formData.append("material_id", id);
  //   }
  //   if (imageFile !== null) {
  //     formData.append("image_file", imageFile);
  //   }

  //   formData.append("user_query", inputPrompt);
  //   formData.append("session_id", localStorage.getItem("session_id") || "");
  //   formData.append("history", []);

  //   const token = localStorage.getItem("access_token") || null;

  //   try {
  //     const response = await axios.post(POST_AIRA_AUDIO, formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/form-data",
  //       },
  //       withCredentials: true,
  //     });

  //     const history = groupMessagesInPairs(response?.data?.updated_history);

  //     setSessionHistory(history);
  //     dispatch(chatHistoryOneDay(1));
  //     setInputPrompt("");
  //     setQuestion("Our AI tools help students understand better, improve their learning.");
  //     setPromptQues("");
  //     const session_id = response.data.session_id;
  //     localStorage.setItem("session_id", session_id);
  //     setDocResponse(false);
  //   } catch (error) {
  //     setDocResponse(false);
  //     setToastState({
  //       show: true,
  //       message: "Unable to generate response.",
  //       error,
  //       type: "error",
  //     });
  //   }
  // };

const sendDocument = async () => {
  setInputPrompt("");
  setDocResponse(true);
  const id = localStorage.getItem("material_id");
  const formData = new FormData();

  if (id) {
    formData.append("material_id", id);
  }
  if (imageFile !== null) {
    formData.append("image_file", imageFile);
  }

  formData.append("user_query", inputPrompt);
  formData.append("session_id", localStorage.getItem("session_id") || "");
  formData.append("history", []);

  const token = localStorage.getItem("access_token") || null;

  const currentList =
    sessionHistory?.length > 0
      ? sessionHistory
      : historyOneDay?.length > 0
        ? historyOneDay
        : historySevenDay;
  const nextIndex = currentList.length;

  try {
    const response = await axios.post(POST_AIRA_AUDIO, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    });

    const history = groupMessagesInPairs(response?.data?.updated_history);

    setSessionHistory(history);
    dispatch(chatHistoryOneDay(1));
    setInputPrompt("");
    setQuestion("Our AI tools help students understand better, improve their learning.");
    setPromptQues("");
    const session_id = response.data.session_id;
    localStorage.setItem("session_id", session_id);
    setDocResponse(false);

    if (uploadedFilePreview) {
      setSentAttachments((prev) => ({ ...prev, [nextIndex]: uploadedFilePreview }));
    }

    setUploadedFilePreview(null);
    setImageFile(null);
    localStorage.removeItem("material_id");
  } catch (error) {
    setDocResponse(false);
    setToastState({
      show: true,
      message: "Unable to generate response.",
      error,
      type: "error",
    });

    if (uploadedFilePreview?.url) URL.revokeObjectURL(uploadedFilePreview.url);
    setUploadedFilePreview(null);
    setImageFile(null);
    localStorage.removeItem("material_id");
  }
};
  const handleEditCancelBtn = () => {
    setEditing(false);
    setShowEditBtn(true);
    setEditingIndex(null);
  };

  return (
    <section className="aira-chat">
      <div className="chat-index">
        <div className="bdrs28 ts03 ad-block">
          <div className="ad-block__inner">
            <h3 className="fz28 ff-inter text-white fw600">
              8/10 Free Generations
            </h3>
            <button className="fw500 fz16 border-0 btn btn-solid btn-solid--white">
              Upgrade
            </button>
          </div>
        </div>
        <div
          className={`bdrs40 overflow-hidden chat-history ${isHistoryOpen ? "open-history" : ""}`}
        >
          <div className="mb-0 title-992">
            <h5 className="fw900 fz24">History</h5>
            <button
              className="btn btn-round btn-round--green js-close-btn"
              // onClick={() => setIsHistoryOpen(false)}
              // onClick={() => setQuestion( "Our AI tools help students understand better, improve their learning.")}
              
            >
              <img src="./assets/images/Group.png" alt="" />
            </button>
          </div>
          <div className="bdrs12 chat-history__green-block">
            <ul className="list-inline">
              <li>
                <a href="#today" className="">
                  Today
                </a>
              </li>
              <li>
                <a href="#days7" className="">
                  7 days
                </a>
              </li>
              {/* <li>
                <a href="#days30" className="">
                  30 days
                </a>
              </li> */}
            </ul>
          </div>
          <div className="chat-history__list">
            <section id="today" className="history-group today-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">Today</p>
              <ul className="list-unstyled mb-3">
                {chatHistoryOneDayStore &&
                  chatHistoryOneDayStore?.map((data) => (
                    <li>
                      <button
                        className="btn border-0 history-info"
                        onClick={(e) => previousChatOneDay(e, data?.session_id)}
                      >
                        {/* <h6 className="fw500">
                          {data?.messages
                            ?.map((c) => (c?.role === "user" ? c?.content : ""))
                            .reverse()}
                        </h6> */}
                        <h6 className="fw500">
                          {data?.messages?.[0]?.content}
                        </h6>
                        <p className="fz10 fw500">
                          {formatDateForChatComponent(data?.timestamp)}
                        </p>
                      </button>
                    </li>
                  ))}
              </ul>
            </section>

            <section id="days7" className="history-group days7-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">7 days</p>
              <ul className="list-unstyled mb-4">
                {chatHistorySevenStore &&
                  chatHistorySevenStore?.map((data) => (
                    <li>
                      <a
                        href="#"
                        className="history-info"
                        onClick={(e) =>
                          previousChatSevenDay(e, data?.session_id)
                        }
                      >
                        {/* <h6 className="fw500">
                          {data?.messages
                            ?.map((c) => (c?.role === "user" ? c?.content[0] : ""))
                            .reverse()}
                        </h6> */}
                        <h6 className="fw500">
                          {data?.messages?.[0]?.content}
                        </h6>
                        <p className="fz10 fw500">
                          {formatDateForChatComponent(data?.timestamp)}
                        </p>
                      </a>
                    </li>
                  ))}
              </ul>
            </section>
            {/* <section id="days30" className="history-group days30-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">30 days</p>
              <ul className="list-unstyled mb-0">
                {chatHistoryMonthStore &&
                  chatHistoryMonthStore?.map((data) => (
                    <li>
                      <a href="#" className="history-info">
                        <h6 className="fw500">
                          {data?.messages?.map((c) =>
                            c?.role === "user" ? c?.content : ""
                          )}
                        </h6>
                        <p className="fz10 fw500">
                          {formatDateForChatComponent(data?.timestamp)}
                        </p>
                      </a>
                    </li>
                  ))}
              </ul>
            </section> */}
          </div>
        </div>
      </div>
      <div className="pb-0 bdrs30 chat-area chat-area--aira">
        <div className="title-row">
          <div className="title-row__left">
            <h2 className="fw900 fz28">Chat with AI</h2>
            {/* <p className="fw500 mb-0 fz16">
              Lorem Ipsum&nbsp;is simply dummy text of the printing.
            </p> */}
          </div>
          <div className="title-row__right" onClick={handleNewChat}>
            <button className="btn btn-solid bdrs20 btn-solid--dark">
              <img
                src="./assets/images/inner-pages/icons/icon-new-chat.svg"
                alt=""
              />
              <span className="fw500 text-white fz20">New chat</span>
            </button>
            <button
              className="btn btn-round btn-round--actions js-history-btn hide-above-768"
              onClick={() => setIsHistoryOpen(true)}
            >
              <img
                src="./assets/images/inner-pages/icons/icon-history-aira-chat.svg"
                alt=""
              />
            </button>
          </div>
        </div>

        {/* chat history section from redux */}
        {(sessionHistory?.length > 0
          ? sessionHistory
          : historyOneDay?.length > 0
            ? historyOneDay
            : historySevenDay
        ).map((data, index) => (
          <>
            <div className="bdrs20 user-row user-row--aira">
            {editingIndex === index ? (
  <div className="position-relative w-100">
    {sentAttachments[index] && (
      <div className="d-flex align-items-center gap-2 mb-2">
        {sentAttachments[index].type === "image" ? (
          <img
            src={sentAttachments[index].url}
            alt="attachment"
            style={{ width: 32, height: 32, objectFit: "cover", borderRadius: 6 }}
          />
        ) : (
          <img
            src="./assets/images/inner-pages/icons/file-earmark-pdf.svg"
            alt="doc"
            style={{ width: 24, height: 24 }}
          />
        )}
        <span className="fz12 fw500 text-white text-truncate" style={{ maxWidth: 200 }}>
          {sentAttachments[index].name}
        </span>
      </div>
    )}
    <input
      type="text"
      value={question}
      onChange={(e) => setQuestion(e.target.value)}
      className="form-control fz20 input-with-buttons"
      onKeyDown={(e) => {
        if (e.key === "Enter" && question.trim()) {
          handleEditPrompt();
          setEditingIndex(null);
        }
      }}
    />
    {/* cancel button */}
    <div className="action-buttons-inside-input">
      <button
        className="border-0 btn btn-sm btn-light"
        onClick={handleEditCancelBtn}
      >
        <img
          src="./assets/images/x-circle-fill.svg"
          alt="cancel"
          class="rounded-full custom-icon"
        />
      </button>

      {/* submit button */}
      <button
        className="border-0 btn btn-sm btn-light"
        onClick={() => {
          handleEditPrompt();
        }}
      >
        <img
          src="./assets/images/arrow-right-square-fill.svg"
          alt="submit"
          class="custom-icon"
        />
      </button>
    </div>
  </div>
) : (
              <>
      {sentAttachments[index] && (
        <div className="d-flex align-items-center gap-2 me-2">
          {sentAttachments[index].type === "image" ? (
            <img
              src={sentAttachments[index].url}
              alt="attachment"
              style={{ width: 32, height: 32, objectFit: "cover", borderRadius: 6 }}
            />
          ) : (
            <img
              src="./assets/images/inner-pages/icons/file-earmark-pdf.svg"
              alt="doc"
              style={{ width: 24, height: 24 }}
            />
          )}
          <span className="fz12 fw500 text-white text-truncate" style={{ maxWidth: 140 }}>
            {sentAttachments[index].name}
          </span>
        </div>
      )}
      <p className="mb-0 text-white ff1 fz18 fw500">
        {data
          ?.map((d) => (d?.role === "user" ? d?.content : ""))
          .join("")}
      </p>
    </>
  )}

              {showEditBtn && editingIndex !== index && (
                <button
                  className="ms-auto btn btn-round btn-round--edit"
                  onClick={() => {
                    setQuestion(
                      data
                        ?.map((d) => (d?.role === "user" ? d?.content : ""))
                        .join(""),
                    );
                    setEditingIndex(index);
                    setEditing(true);
                  }}
                >
                  <img
                    src="./assets/images/inner-pages/icons/icon-edit.svg"
                    alt=""
                  />
                </button>
              )}
            </div>
            <div className="reply-area">
              <div className="bdrs30 reply-area__top">
                <div className="rounded-circle logo-left">
                  <img src="./assets/images/Group.png" alt="" />
                </div>
                <div className="text-content">
                  <MarkdownRenderer
                    markdown={formatMarkdownResponse(
                      data
                        ?.map((d) =>
                          d?.role === "assistant" ? d?.content : "",
                        )
                        .join(""),
                    )}
                  />
                </div>
              </div>
              <div className="bdrs30 reply-area__bottom">
                <div className="p-0 mt-auto bdrs30 actions">
                  <ul className="bdrs28 list-inline mb-0">
                    <SpeakerCopyButton
                      text={data
                        ?.filter((d) => d?.role === "assistant")
                        .map((d) => d?.content.trim()) // ensure text is clean
                        .join(" ")}
                      index={index}
                    />

                    <li>
                      <button className="btn btn-round btn-round--actions">
                        <img
                          src="./assets/images/inner-pages/icons/icon-thumbs-up.svg"
                          alt=""
                        />
                      </button>
                    </li>
                    <li>
                      <button className="btn btn-round btn-round--actions">
                        <img
                          src="./assets/images/inner-pages/icons/icon-thumbs-down.svg"
                          alt=""
                        />
                      </button>
                    </li>
                  </ul>
                  {/* <span className="ff1 num-count text-dark">1200</span> */}
                </div>

                <div className="cta-regenrate">
                  <button
                    className="btn btn-solid btn-solid--dark"
                    onClick={() => handleRegenerate(data)}
                  >
                    <img
                      src="./assets/images/inner-pages/icons/icon-refresh.svg"
                      alt=""
                    />
                    <span className="ff2 fz16 text-nowrap fw500">
                      Regenerate Response
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </>
        ))}

        {/* static chat section */}

        <>
         <div className="bdrs20 user-row user-row--aira">
  <img
    src="./assets/images/inner-pages/icons/icon-nav-user.svg"
    alt=""
  />

  {uploadedFilePreview && (
    <div className="d-flex align-items-center gap-2 me-2">
      {uploadedFilePreview.type === "image" ? (
        <img
          src={uploadedFilePreview.url}
          alt="attachment"
          style={{ width: 32, height: 32, objectFit: "cover", borderRadius: 6 }}
        />
      ) : (
        <img
          src="./assets/images/inner-pages/icons/file-earmark-pdf.svg"
          alt="doc"
          style={{ width: 24, height: 24 }}
        />
      )}
      <span className="fz12 fw500 text-white text-truncate" style={{ maxWidth: 140 }}>
        {uploadedFilePreview.name}
      </span>
    </div>
  )}

  <p className="mb-0 fz18 text-white fw500">
    {promptQues
      ? promptQues : question ? question
      : "Our AI tools help students understand better, improve their learning."}
  </p>
  <button className="ms-auto btn btn-round btn-round--edit">
    <img
      src="./assets/images/inner-pages/icons/icon-edit.svg"
      alt=""
    />
  </button>
</div>
          <div className="reply-area">
            <div className="bdrs30 reply-area__top">
              <div className="rounded-circle logo-left">
                <img src="./assets/images/Group.png" alt="" />
              </div>
              <div className="text-content">
                {(chatLoading && !chatResponse) ||
                recordingStarted ||
                docResponse ? (
                  <div className="loading-text">
                    <i>Generating response...</i>
                  </div>
                ) : (
                  <div className="loading-text">
                    <strong>
                      You can ask any problem and we will help you.
                    </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
        
           {uploadedFilePreview && (
    <div className="bdrs12 attachment-preview d-flex align-items-center gap-2 mb-2 p-2">
      {uploadedFilePreview.type === "image" ? (
        <img
          src={uploadedFilePreview.url}
          alt="attachment"
          style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 8 }}
        />
      ) : (
        <img
          src="./assets/images/inner-pages/icons/file-earmark-pdf.svg"
          alt="doc"
          style={{ width: 32, height: 32 }}
        />
      )}
      <span className="fz14 fw500 text-truncate" style={{ maxWidth: 200 }}>
        {uploadedFilePreview.name}
           <button
        type="button"
        className="btn btn-sm border-0 ms-auto"
        onClick={handleRemoveAttachment}
      >
        <img
          src="./assets/images/x-circle-fill.svg"
          alt="remove"
          className="custom-icon"
        />
      </button>
      </span>
   
    </div>
  )}
  <div className="send-message-row">
          <div className="form-group">
            <img
              src="./assets/images/inner-pages/icons/icon-keyboard.svg"
              alt=""
              className="position-absolute icon-keyboard"
            />
            <input
              type="text"
              value={inputPrompt}
              onChange={(e) => {
                setInputPrompt(e.target.value);
                setPromptQues(e.target.value);
              }}
              className="border-0 form-control fz16"
              placeholder="Ask me something..."
              onKeyDown={(e) => {
                if (e.key === "Enter" && inputPrompt.trim())
                  localStorage.getItem("material_id")
                    ? sendDocument()
                    : handleSendPrompt();
              }}
            />

            <div className="dropdown dropup file-down">
              <button
                className="btn p-0 border-0 file-attach-btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="./assets/images/inner-pages/icons/paperclip.svg"
                  alt="Attach"
                  className="custom-icon"
                />
              </button>

              <div class="dropdown-menu">
                <div
                  className="dropdown-item"
                  onClick={() => imageInputRef.current?.click()}
                >
                  <img
                    src="./assets/images/inner-pages/icons/file-image.svg"
                    alt="Image Upload"
                    className="custom-icon"
                  />
                  <span className="">upload image</span>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={imageInputRef}
                  className="d-none"
                  onChange={handleImageUpload}
                />

                <div
                  className="dropdown-item"
                  onClick={() => docInputRef.current?.click()}
                >
                  <img
                    src="./assets/images/inner-pages/icons/file-earmark-pdf.svg"
                    alt="Document Upload"
                    className="custom-icon"
                  />
                  <span className="">upload document</span>
                </div>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.txt"
                  ref={docInputRef}
                  className="d-none"
                  onChange={handleDocUpload}
                />
              </div>
            </div>
          </div>

          <button
            onClick={isRecording ? stopRecording : startRecording}
            className="btn btn-round btn-round--dark"
          >
            <img
              src={
                isRecording
                  ? "./assets/images/inner-pages/icons/stop-circle.svg"
                  : "./assets/images/inner-pages/icons/icon-mic.svg"
              }
              alt="Mic"
            />
          </button>

          <button
            onClick={
              localStorage.getItem("material_id")
                ? sendDocument
                : handleSendPrompt
            }
            className="btn btn-round btn-round--gray"
          >
            <img
              src="./assets/images/inner-pages/icons/icon-send.svg"
              alt="Send"
            />
          </button>
        </div>
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default AiraChatBody;
